'use strict';

var COMPONENTS_GERMAN_LANG = 'de';
var COMPONENTS_ENGLISH_LANG = 'en';

angular.module('idai.components',[]);


'use strict';

angular.module('idai.components')
.factory('countries', ['$http', 'language', '$q',
		function($http, language, $q) {

			var deferred = $q.defer();

			var translationLang=COMPONENTS_ENGLISH_LANG;
			var countries = null;
			if (language.currentLanguage()==COMPONENTS_GERMAN_LANG) translationLang=COMPONENTS_GERMAN_LANG;

			//TODO load countries.json from inside components-module
	        $http.get('info/countries.json').then(function (response) {
	            countries = [];
	            response.data.forEach(function(ctry){
	            	countries.push({
		            	name: ctry['name_' + translationLang],
		            	iso_2: ctry['iso_2']
	            	});
	            });
	            deferred.resolve(countries);
	        });

		    var factory = {};

		    factory.getCountriesAsync = function() {
		        return deferred.promise;
		    };

		    factory.getCountries = function() {
		        return countries;
		    };

		    return factory;
		}
	]);

'use strict';

angular.module('idai.components')


.directive('idaiCountryPicker', function() {
    return {
        restrict: 'E',
        templateUrl: 'forms/idai-country-picker.html',
        scope: {
            model: '='
        },
        controller: [ '$scope', 'countries',
            function($scope, countries) {
                countries.getCountriesAsync().then(function (countries) {
                	$scope.countries = countries;
                });
            }]
    }});
'use strict';

angular.module('idai.components')

/** 
 * @author: Sebastian Cuy
 */

 .directive('idaiPicker', function() {
	return {
		restrict: 'E',
		scope: {
			searchUri: '@',	resultField: '@', titleField: '@',
			totalField: '@', queryParam: '@', limitParam: '@',
			offsetParam: '@', addParams: '=', selectedItem: '='
		},
		templateUrl: 'forms/idai-picker.html',
		controller: [ '$scope', '$parse', '$uibModal',
			function($scope, $parse, $modal) {

				$scope.openModal = function() {
					var modal = $modal.open({
						templateUrl: "picker_modal.html",
						controller: "PickerModalController",
						bindToController: true,
						size: 'lg',
						scope: $scope
					});
					modal.result.then(function(item) {
						$scope.selectedItem = item;
					});
				};

				$scope.$watch("titleField", function(titleField) {
					if (!titleField) titleField = "title";
					$scope.getTitleField = $parse(titleField);
				});

			}
		]
	}
});

'use strict';

angular.module('idai.components')


/**
 * @author Patrick Jominet
 * @author Jan Wieners
 * @author Daniel de Oliveira
 * @author philipp Franck
 *
 */
.component('idaiSearch', {
    restrict: 'E',
    templateUrl: 'forms/idai-search.html',
    bindings: {
        buttonClass: '@',
        searchScope: '<'
    },
    controller: [ '$scope', '$location', 'componentsSettings', '$http','idaiSearchService',
        function($scope,$location,componentsSettings,$http,idaiSearchService) {

            var NUM_SEARCHES_TO_KEEP = 3;
            var localStorageKey='previousSearchQueries';
            $scope.placeholder = undefined;

            $scope.buttonClass = 'btn-primary';
            if (this.buttonClass) {
                $scope.buttonClass = this.buttonClass;
            }

			/**
			 * [scoped search]
			 *
			 * about: I tried to make it flexible, that the component can be used in a system with different architecture as well..
			 *
			 * the value serachScope takes one object,
			 * with 4 optional parameters
			 *
			 * searchScope.title - the title of the scope
			 * searchScope.search - a function taking the serach query q and returning the query url
			 * searchScope.leaveScope - a function get called when leave scope is clicked
			 * searchScope.page - url of the info page of the scope
			 *
			 *
			 */

            $scope.noSearchScope = false;
            var lastScope = ''; //  we track this to know, when scope is changed and removed scope button shall be shown again

			$scope.getSearchScopeShortTitle = function() {
				if (!angular.isObject(this.searchScope)) {
					return false;
				}
				if (!this.searchScope.title  || (this.searchScope.title === '')) {
					return false;
                }
                if (this.searchScope.title.length > 10) {
                    return this.searchScope.title.substr(0, 7) + '...';
                }
                return this.searchScope.title;
            }.bind(this);

			$scope.getSearchScope = function() {
			    return this.searchScope
            }.bind(this);

			var getScopeSearchUrl = function(q) {
				if (angular.isObject(this.searchScope) && angular.isFunction(this.searchScope.search)) {
					return this.searchScope.search(q);
				} else {
					return '/search?q=' + q;
				}
			}.bind(this);

            $scope.hasSearchScope = function()  {

            	var searchScopeGiven = angular.isObject(this.searchScope) &&
                    (this.searchScope.page || this.searchScope.title);
            	// serach scope button is visible when there is a title and/or a scope homepage

            	if (searchScopeGiven) {
					if (lastScope !== JSON.stringify(this.searchScope.title))  {
						lastScope = JSON.stringify(this.searchScope.title);
						$scope.noSearchScope = false;
					}
				} else {
                    lastScope = '';
					$scope.noSearchScope = false;
				}

            	return searchScopeGiven && !$scope.noSearchScope;
			}.bind(this);

			$scope.leaveSearchScope = function leaveSearchScope() {
				if (angular.isObject(this.searchScope) && angular.isFunction(this.searchScope.leaveScope)) {
					this.searchScope.leaveScope();
				}
				$scope.noSearchScope = true;
			}.bind(this);


            idaiSearchService.register(function(term) {
                $scope.placeholder = term;
            }.bind(this));

            // -- end scoped serach -- //

            $scope.$on('$locationChangeStart', function (event,next) { // ????
                if (next.indexOf('search')==-1) idaiSearchService.notify(undefined)
                $scope.q = $location.search().q
            });


            $scope.search = function ($item) {
                var searchTerm;
                if ($item) {
                    searchTerm = '"' + $item.model + '"';
                } else {
                    searchTerm = $scope.q;
                }
                memorizeSearch(searchTerm,NUM_SEARCHES_TO_KEEP);

                $scope.q = searchTerm;

                if (!searchTerm) searchTerm = "";

                var url = getScopeSearchUrl(searchTerm);

		$location.url(url);

                idaiSearchService.notify(searchTerm);
            };

            $scope.selectQueryString = function (event) {
                event.target.select();
            }


            $scope.getSuggestions = function (value) {
                if (!componentsSettings.searchUri) return;

                return $http.get(componentsSettings.searchUri + value)
                    .then(function (response) {
                        if (!response.data.suggestions) return [];

                        var suggestions=
                            response.data.suggestions.map(function(e){return {model:e}});
                        if (!suggestions) return [];
                        enrichWithOldQueries(suggestions);
                        return suggestions;
                    });
            };

            function enrichWithOldQueries(suggestions) {
                var queries = JSON.parse(localStorage.getItem(localStorageKey));
                if (queries) {
                    queries.reverse();
                    queries.forEach(function(term){
                        suggestions.push({model:term,extra:true})
                    });
                }
            }

            function memorizeSearch(searchTerm,searchesToKeep) {

                var queries = JSON.parse(localStorage.getItem(localStorageKey));

                if (queries === null || !queries) {
                    queries = [searchTerm];
                } else {

                    queries.push(searchTerm);

                    // Make unique
                    queries = queries.filter(function(item, pos) {
                        return queries.indexOf(item) == pos;
                    });

                    if (queries.length > searchesToKeep +1) {
                        queries.shift();
                    }
                }
                localStorage.setItem(localStorageKey, JSON.stringify(queries));
            }
        }
    ]
});

'use strict';

angular.module('idai.components')

    .factory('idaiSearchService',
            function() {

                var subscribers=[];

                return {

                    register: function(callback) {
                        subscribers.push(callback);
                    },

                    notify: function(term) {
                        for (var i in subscribers) {
                            subscribers[i](term);
                        }
                    }
                }
            }
    );
'use strict';

angular.module('idai.components')
    
/**
 * @author: Sebastian Cuy
 */
.controller('PickerModalController', [ '$scope', '$http', '$q', '$parse', '$uibModalInstance',
    function($scope, $http, $q, $parse, $modalInstance) {

        var canceler;

        $scope.result;
        $scope.total = 0;
        $scope.offset = 0;
        $scope.limit = 10;
        $scope.loading = false;
        $scope.preselect = 0;

        var search = function() {
            if (canceler) canceler.resolve();
            if ($scope.query) {
                $scope.loading = true;
                canceler = $q.defer();
                if (!$scope.queryParam) $scope.queryParam = "q";
                if (!$scope.limitParam) $scope.limitParam = "limit";
                if (!$scope.offsetParam) $scope.offsetParam = "offset";
                var requestUri = $scope.searchUri + "?" + $scope.queryParam + "=" + $scope.query;
                requestUri += "&" + $scope.limitParam + "=" + $scope.limit;
                requestUri += "&" + $scope.offsetParam + "=" + $scope.offset;
                if ($scope.addParams) {
                    angular.forEach($scope.addParams, function(value, key) {
                        requestUri += "&" + key + "=" + value;
                    });
                }
                $http.get(requestUri, { timeout: canceler.promise }).then(function(response) {
                    if (!$scope.resultField) $scope.resultField = "result";
                    var getResultField = $parse($scope.resultField);
                    if ($scope.offset == 0) {
                        $scope.result = getResultField(response.data);
                    } else {
                        $scope.result = $scope.result.concat(getResultField(response.data));
                    }
                    if (!$scope.totalField) $scope.totalField = "total";
                    var getTotalField = $parse($scope.totalField);
                    $scope.total = getTotalField(response.data);
                    $scope.loading = false;
                });
            } else {
                $scope.result = [];
                $scope.total = 0;
            }
        };

        $scope.more = function() {
            $scope.offset += $scope.limit;
            search();
        };

        $scope.keydown = function($event) {
            // arrow down preselects next item
            if ($event.keyCode == 40 && $scope.preselect < $scope.result.length - 1) {
                $scope.preselect++;
                // arrow up select precious item
            } else if ($event.keyCode == 38 && $scope.preselect > 0) {
                $scope.preselect--;
            }
        };

        $scope.keypress = function($event) {
            // enter selects preselected item (if query has not changed)
            if ($event.keyCode == 13) {
                if ($scope.total > 0 && $scope.query == $scope.lastQuery) {
                    $event.stopPropagation();
                    $scope.selectItem($scope.result[$scope.preselect]);
                } else {
                    $scope.newQuery();
                }
            }
        };

        $scope.newQuery = function() {
            $scope.lastQuery = $scope.query;
            $scope.offset = 0;
            search();
        };

        $scope.open = function(uri) {
            window.open(uri, '_blank');
        };

        $scope.selectItem = function(item) {
            $modalInstance.close(item);
        };

        $scope.$watch("titleField", function(titleField) {
            if (!titleField) titleField = "title";
            $scope.getTitleField = $parse(titleField);
        });

    }
]);

'use strict';

angular.module('idai.components')

/**
 * Given a language, determines by a
 * rule if this language is applicable or if not which
 * other language is applicable in a given context.
 * Once found a suitable language, an operation to
 * apply that language in the clients context gets performed.
 *
 * @author: Daniel de Oliveira
 */
    .factory('languageSelection', ['language', function (language) {

        return {

            /**
             * The language selection rule.
             *
             * @param isLangApplicable - callback function(lang,param) for testing
             *   if lang is applicable in the clients context
             * @param applyLang - callback function(lang_,param) for applying
             *   lang in the clients context
             * @param param - used as second param for the callbacks
             */
            __: function (isLangApplicable, applyLang, param) {

                var lang = localStorage.getItem('lang');

                if (lang) {

                    if (lang === COMPONENTS_GERMAN_LANG || lang === COMPONENTS_ENGLISH_LANG) {
                        applyLang(lang, param);
                        return;
                    }
                }

                if (language.currentLanguage() == COMPONENTS_GERMAN_LANG) {
                    applyLang(COMPONENTS_GERMAN_LANG, param);
                    return;
                }

                if (isLangApplicable(language.currentLanguage(), param)) {
                    applyLang(language.currentLanguage(), param);
                } else if (language.currentLanguage() == COMPONENTS_ENGLISH_LANG) {
                    applyLang(COMPONENTS_GERMAN_LANG, param);
                } else if (isLangApplicable(COMPONENTS_ENGLISH_LANG, param))
                    applyLang(COMPONENTS_ENGLISH_LANG, param);
                else
                    applyLang(COMPONENTS_GERMAN_LANG, param);
            }
        }
    }]);

'use strict';

angular.module('idai.components')

/**
 * @return: the users primary browser language.
 * For german languages (de-*) it shortens the language code to "de".
 * For english languages (en-*) it returns the language code to "en".
 *
 * @author: Daniel de Oliveira
 */
.factory('language', function(){

	var lang=navigator.languages ?
		navigator.languages[0] :
		(navigator.language || navigator.userLanguage);

	return {
		originalBrowserLanguage : function(){
			return lang;
		},
		browserLanguage : function() {
			return this.originalBrowserLanguage().substring(0,2);
		},
		currentLanguage : function(){

            var currentLang = this.browserLanguage();

            // Use user-chosen language settings by using idai-components language-switcher
            var lang = localStorage.getItem('lang');
            if (lang) currentLang = lang;

			return currentLang;
		}
	}
});




'use strict';

/**
 * Perform localization related tasks on
 * tree structure exemplified by:
 *
 * node
 *   id: the_id,
 *   title: ( lang_a : title_lang_a, lang_b : title_lang_b ),
 *   children: [ node, node, node ]
 *
 * @author: Daniel de Oliveira
 */
angular.module('idai.components')

    .factory('localizedContent',
        ['languageSelection', function (languageSelection) {

            return {

                /**
                 * Walks trough all elements of the tree
                 * and adjusts the titles of nodes to only appear
                 * in one language.
                 *
                 * The choice is being made for each node independently
                 * of the other nodes via the language selection
                 * rule, taking into consideration the availability of the
                 * languages of the node.
                 *
                 * Tree structure before:
                 *
                 * node
                 *   id: the_id,
                 *   title: ( lang_a : title_lang_a, lang_b : title_lang_b ),
                 *   children: [ node, node, node ]
                 *
                 * Tree structure after:
                 *
                 * node
                 *   id: the_id,
                 *   title: title_lang_b,
                 *   children: [ node, node, node ]
                 */
                reduceTitles: function (node) {

                    var adjustTitleForLang = function (lang, node) {

                        if (node.title) {

                            if (node.title[lang]) {
                                node.title = node.title[lang];
                            } else {
                                // Use title from available language as default / fallback title
                                var language = Object.keys(node.title)[0];
                                node.title = node.title[Object.keys(node.title)[0]];
                                node.fallbackLanguage = language;
                            }
                        }
                    };

                    var isTitleAvailableForLang = function (lang, node) {

                        if (!node.title) {
                            return false;
                        }

                        if (node.title[lang]) {
                            return node.title[lang];
                        }

                        // Use title from available language as fallback title
                        var language = Object.keys(node.title)[0];
                        node.fallbackLanguage = language;
                        return node.title[Object.keys(node.title)[0]];
                    };

                    var recurseProjectsToAdjustTitle = function (node) {

                        languageSelection.__(isTitleAvailableForLang, adjustTitleForLang, node);

                        if (!node.children) return;
                        for (var i = 0; i < node.children.length; i++) {
                            recurseProjectsToAdjustTitle(node.children[i]);
                        }
                    };

                    recurseProjectsToAdjustTitle(node);
                },

                /**
                 * Walks through all elements of the tree and
                 * determines which language for a node of
                 * a given title is applicable.
                 *
                 * The choice is beeing made via the language selection
                 * rule, taking into consideration the availability of the
                 * languages of the node.
                 *
                 * @param node
                 * @param title
                 */
                determineLanguage: function (node, title) {

                    var ret_language = '';

                    /**
                     * Searches recursively through an object tree and
                     * determines if there is a node whose title matches
                     * *title* and which has a title for lang.
                     *
                     * Abstract tree structure:
                     * node
                     *   id: the_id,
                     *   title: ( lang_a : title, lang_b : title ),
                     *   children: [ node, node, node ]
                     *
                     * @param lang
                     * @param node the root of the object tree.
                     * @returns true if there is at least one item
                     *   meeting the above mentioned condition. false
                     *   otherwise.
                     */
                    var isNodeAvailableForLang = function (lang, node) {

                        var recursive = function (node) {
                            if (node.id == title && node.title[lang]) return true;
                            if (node.children)
                                for (var i = 0; i < node.children.length; i++)
                                    if (recursive(node.children[i])) return true;
                            return false;
                        };
                        if (recursive(node)) return true;
                        return false;
                    };

                    var setLang = function (lang) {
                        ret_language = lang;
                    };

                    languageSelection.__(isNodeAvailableForLang, setLang, node);
                    return ret_language;
                },

                /**
                 * Walks through the elements of the tree
                 * until it finds a node of the given id.
                 *
                 * @return reference to the first node
                 *   found whose id matches param id.
                 *   undefined if no node could for the id
                 *   could be found.
                 */
                getNodeById: function (node, id) {

                    var recurse = function (node, id) {
                        if (node.id == id) return node;
                        if (!node.children) return undefined;
                        var foundNode = undefined;
                        for (var i = 0; i < node.children.length; i++) {
                            var retval = recurse(node.children[i], id);
                            if (retval != undefined) foundNode = retval;
                        }
                        return foundNode;

                    };
                    return recurse(node, id);
                }
            };
        }]);

'use strict';

/* Services */
angular.module('idai.components')

/**
 * @author: Daniel de Oliveira
 */
    .filter('transl8Number', ['language', function(language){

        var filterFunction = function(nu) {

            if (typeof nu == 'undefined') return undefined;

			if (typeof nu === 'string' && isNaN(nu)) return nu;

			var num = (typeof nu === 'string' && !isNaN(nu)) ? +nu : nu;

            if (language.currentLanguage() == COMPONENTS_GERMAN_LANG) {
                return num.toLocaleString(COMPONENTS_GERMAN_LANG+"-DE");
            } else {
                return num.toLocaleString(COMPONENTS_ENGLISH_LANG+"-US");
            }
        };
        return filterFunction;
    }]);

'use strict';

/* Services */
angular.module('idai.components')

/**
 * @author: Daniel de Oliveira
 */
.filter('transl8', ['transl8',function(transl8){

	var filterFunction = function(key) {
        if (typeof key == 'undefined') return undefined;
        var trans;
        try {
            trans = transl8.getTranslation(key);
        } catch (err) {
            var msg = "TRL8 MISSING ('"+key+"')";
            console.log(msg);
            return msg;
        }
		return trans;
	};
	return filterFunction;
}]);

'use strict';

/**
 * Provides translations for keys based on the primary browser language of the user.
 * Makes use of the CoDArchLab Transl8 tool.
 *
 * @author: Daniel de Oliveira
 * @author: Jan G. Wieners
 * @author: Sebastian Cuy
 */
angular.module('idai.components')
    .factory('transl8', ['$location', 'language', 'componentsSettings', 'transl8map',
        function ($location, language, componentsSettings, transl8map) {

            var lang = language.currentLanguage(),
                i, translations = {}; // Map: [transl8_key,translation]

            if (['de', 'en'].indexOf(lang) === -1) lang = 'en';

            translations = transl8map[lang];

            return {

                /**
                 * @param key an existing key in transl8 with
                 *   translations for all existing language sets.
                 * @returns translation text
                 * @throws Error if the key does not exist in transl8 or
                 *   there is no translation for the given key.
                 */
                getTranslation: function(key) {

                    var translation = translations[key];
                    if (!translation || 0 === translation.length) {
                        throw new Error("No translation found for key '" + key + "'");
                    }
                    return translation;
                },

                onLoaded: function () {
                    return Promise.resolve();
                }

            }
        }
    ]);

'use strict';

angular.module('idai.components')

    /**
     * @author: Jan G. Wieners
     */
    .factory('header', function () {

    });
'use strict';

angular.module('idai.components')


/**
 * @author: Daniel de Oliveira
 * @author: Jan G. Wieners
 */

    .directive('idaiFooter', function () {
        return {
            restrict: 'E',
            scope: {
                institutions: '=',
                version: '@',
                contentInfo: '=',
            },
            transclude: true,
            templateUrl: 'layout/idai-footer.html',
            controller: ['$scope', 'localizedContent', '$transclude', 'componentsSettings',
                function ($scope, localizedContent, $transclude, componentsSettings) {

                    $scope.dataProtectionPolicyUri = componentsSettings.dataProtectionPolicyUri;
                    $scope.mailto = componentsSettings.mailTo;

                    $transclude(function(clone){
                        $scope.hasTranscludedContent = (clone.length > 0);
                    });

                    $scope.date = new Date();
                    $scope.getFooterLinks = function () {

                        if ($scope.contentInfo) {
                            var footerLinks = localizedContent.getNodeById($scope.contentInfo, 'footer');

                            if (!footerLinks) {
                                console.error('error: no footer links found in file ' + $scope.contentInfo);
                            } else {
                                localizedContent.reduceTitles(footerLinks);
                                $scope.dynamicLinkList = footerLinks.children;
                            }
                        }
                    }
                }],
            link: function (scope) {

                scope.getFooterLinks();
            }
        }
    });

'use strict';

angular.module('idai.components')

/** 
 * @author: Sebastian Cuy
 */

 .directive('idaiForm', function() {
	return {
		restrict: 'E',
        transclude: true,
		scope: {
			submit: '&', doc: '='
		},
		templateUrl: 'layout/idai-form.html',
		link: function(scope, elem, attrs) {

			scope.reset = function() {
				scope.doc = {};
			};

		}
	}
});

'use strict';

angular.module('idai.components')

    /**
     * @author: Jan G. Wieners
     */
    .directive('idaiHeader', function () {
        return {
            restrict: 'E',
            //replace: 'true',
            scope: {
                image: '@',
                description: '@',
                link: '@'
            },
            templateUrl: 'layout/idai-header.html'
        }
    });
'use strict';

/* Directives */
angular.module('idai.components')


/**
 * @author: Daniel de Oliveira
 * @author: Jan G. Wieners
 */

    .directive('idaiNavbar', function() {
        return {
            restrict: 'E',
            scope: {
                userObject: '=',
                loginFunction: '&',
                logoutFunction: '&',
                hideSearchForm: '=',
                hideRegisterButton: '=', // set "true" to hide it
                hideContactButton: '=', // set "true" to hide it
                hideLanguageSwitcher: '=', // set "true" to hide it
                projectId: '@',
                searchScope: '=',
                contentInfo: '=',
            },
            templateUrl: 'layout/idai-navbar.html',
            transclude: true,
            controller: [ '$scope', 'localizedContent', '$window', 'language',
                function($scope, localizedContent, $window, language) {

                    $scope.langCode = language.currentLanguage();

                    $scope.getNavbarLinks = function(){

						if ($scope.contentInfo) {
							var navbarLinks = localizedContent.getNodeById($scope.contentInfo, 'navbar');

							if (!navbarLinks) {
								console.error('error: no navbar links found in file ' + $scope.contentInfo);
							} else {
								localizedContent.reduceTitles(navbarLinks);
								$scope.dynamicLinkList = navbarLinks.children;
							}
						}
                    };

                    $scope.toggleNavbar = function() {

                            $scope.isCollapsed = true;
                            $scope.$on('$routeChangeSuccess', function () {
                                $scope.isCollapsed = true;
                            });
                    };

                    $scope.switchLanguage = function(lang) {
                        localStorage.setItem('lang', lang);
                        $window.location.reload();
                    };

                }],
            link: function(scope){
                scope.getNavbarLinks();
            }
        }});

'use strict';

angular.module('idai.components')


/**
 * @author: Daniel de Oliveira
 */
.component('idaiMessages', {
        restrict: 'E',
        templateUrl: 'messages/idai-messages.html',
        controller: [ '$scope', 'messageService',
            function($scope,messages) {

                $scope.messages = messages.all();

                $scope.remove = function(transl8Key){
                    messages.remove(transl8Key)
                };

            }]
    }
);
'use strict';

/**
 * Message store which holds one or more messages
 * for the purpose of being displayed to the user.
 *
 * Messages are automatically removed on location changes,
 * though this default behavior can be overridden. Messages
 * also can be removed selectively.
 *
 * The message access is based on
 * transl8keys, which are also used to automatically
 * retrieve the message texts via transl8.
 *
 * <b>Note</b> that the basic assumption here is that the
 * iDAI transl8 service tool is up and running and the translations have
 * been fetched when calling methods of the message service.
 * The assumption is made because we say that if the transl8 service is
 * down you cannot navigate anyway so you will not try to perform actions
 * that require communication with users, which is the purpose of this service.
 *
 * Another assumption is that a transl8Key used to add a message exists and
 * that the developer is responsible for creating it prior to using it. For this
 * reason exceptions get thrown if unknown transl8Keys are used.
 *
 * @author Sebastian Cuy
 * @author Daniel de Oliveira
 */
angular.module('idai.components')

.factory('messageService',
    [ '$rootScope', 'transl8', '$sce', 'componentsSettings',
        function( $rootScope, transl8, $sce, componentsSettings ) {

    /**
     * A Map [transl8Key,message].
     */
    var messages = {};

    var clearOnLocationChange = true;


    /**
     * The message data structure.
     * @param transl8Key
     */
    function Message(transl8Key) {
        this.text = transl8.getTranslation(transl8Key);
        this.text = $sce.trustAsHtml(this.text);
        this.level = 'warning';
        this.contactInfo = transl8.getTranslation('components.message.contact')
            .replace('CONTACT', componentsSettings.mailTo);
        
    }

    function isUnknown(level){
        return (['success', 'info', 'warning', 'danger'].indexOf(level) === -1);
    }

    /**
     * Clears all the actual messages.
     * @private
     */
    function _clear() {
        angular.forEach(messages, function(msg, key) {
            delete messages[key];
        });
    }

    /**
     * Creates a new message and adds it to the actual messages.
     * @param transl8Key
     * @returns {*}
     * @private
     */
    function _create(transl8Key) {
        messages[transl8Key]=  new Message(transl8Key);
        return messages[transl8Key];
    }


    /**
     * Clear actual messages when location changes.
     */
    $rootScope.$on("$locationChangeSuccess", function() {
        if (clearOnLocationChange) _clear();
        clearOnLocationChange= true;
    });

    // In case transl8 loaded after(!) messages were already added
    transl8.onLoaded().then(function(){
        angular.forEach(messages, function(msg, key) {
            msg.text = transl8.getTranslation(key);
            msg.text = $sce.trustAsHtml(msg.text);
        });
    });

    return {

        /**
         * Allows clients to specify that the messages are not cleared
         * during the next location change, which would be the default behavior
         * of the message service.
         *
         * NOTE that in order for this to work the angular $location.path()
         * has to be used. It will not work with window.location.href because
         * then everything gets reloaded, including the default
         * value for clearOnLocationChange.
         */
        dontClearOnNextLocationChange: function() {
            clearOnLocationChange= false;
        },

        /**
         * Adds a message to the actual messages. By default, an extra line
         * is appended below the message containing a standard contact info text.
         * This info text will not appear if level is success.
         *
         * @param transl8Key an existing transl8 key.
         *   Used to identify the message and retrieve the message text from transl8.
         * @param level (optional) should be set to one of
         *   'success', 'info', 'warning', 'danger', which are terms from bootstrap.
         *   If not set, the messages level will default to 'warning'.
         * @param showContactInfo boolean. If set and set to false the contact info
         *   line will not be created.
         *
         * @throws Error if level if set but does not match one of the allowed values.
         * @throws Error if there exists no translation for transl8Key.
         */
        add: function(transl8Key, level, showContactInfo) {

            var message = _create(transl8Key);
            if (level) {
                if (isUnknown(level))
                    throw new Error("If used, level must be set to an allowed value.");
                message.level = level;
            }

            if (showContactInfo==false||message.level=='success')
                delete message.contactInfo;
        },

        /**
         * Removes an error message from the actual messages.
         *
         * @param transl8Key the identifier of the message to be removed.
         */
        remove: function(transl8Key) {
            delete messages[transl8Key];
        },


        /**
         * Removes all messages.
         */
        clear: function() {
            _clear();
        },

        all: function() {
            return messages;
        }
    }
}]);
'use strict';

/* Directives */
angular.module('idai.components')


/**
 * @author: Daniel de Oliveira
 */

.directive('includeReplace', function () {
    return {
       	require: 'ngInclude',
       	restrict: 'A', /* optional */
       	link: function (scope, el, attrs) {
           	el.replaceWith(el.children());
       	}  
	}});
angular.module('idai.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('forms/idai-country-picker.html','<select class=form-control ng-model=model><option>- {{\'ui_please_select\'|transl8}} -</option><option ng-repeat="country in countries" value={{country.iso_2}}>{{country.name}}</option></select>');
$templateCache.put('forms/idai-picker.html','<div class=idai-picker><script type=text/ng-template id=picker_modal.html><div class="panel panel-default picker-modal"> <div class="panel-heading"> <form class="input-group"> <input ng-keydown="keydown($event)" ng-keypress="keypress($event)" type="text" ng-model="query" class="form-control" autofocus></input> <span class="input-group-btn"> <button ng-click="newQuery()" class="btn btn-default"> <span class="glyphicon glyphicon-search"></span> </button> </span> </form> </div> <div class="panel-body"> <div ng-if="loading" class="loading"></div> <em ng-show="result && total == 0 && !loading">{{ \'picker_no_result\' | transl8 }}</em> <em ng-show="!result && total == 0 && !loading">{{ \'picker_perform_search\' | transl8 }}</em> <div ng-show="total > 0 && !loading" class="text-center small"> <b><i>{{ total | number }} {{ \'results\' | transl8 }}</i></b> </div> </div> <div class="list-group" style="max-height:470px; overflow-y: auto;"> <a href="#" ng-repeat="item in result" class="list-group-item" ng-click="selectItem(item)" ng-class="{ preselected: $index == preselect }"> <div class="row"> <div ng-class="{ \'col-sm-8\': item[\'@id\'], \'col-sm-12\': !item[\'@id\']}"> <span ng-class="{ invisible: $index != preselect }" class="glyphicon glyphicon-menu-right small"></span> {{ getTitleField(item) }} </div> <div class="col-sm-4 text-right" ng-show="item[\'@id\']"> <button class="btn btn-link btn-xs" ng-click="open(item[\'@id\'])" style="padding:0px 5px 1px; border: 0;"> {{ item[\'@id\'] }} <span class="glyphicon glyphicon-new-window" style="font-size:0.8em"></span> </button> </div> </div> </a> <a ng-show="total > offset + limit" href="#" class="list-group-item text-center" ng-click="more()"> ... </a> </div> </div></script><div class=input-group><span class=input-group-btn><button class="btn btn-default" type=button ng-click=openModal()><span class="glyphicon glyphicon-link"></span></button></span> <span class=form-control><span ng-show=!selectedItem>{{ \'pick_an_item\' | transl8 }}</span> <a ng-show="selectedItem && selectedItem[\'@id\']" ng-href="{{ selectedItem[\'@id\'] }}" target=_blank>{{ getTitleField(selectedItem) }}</a> <span ng-show="selectedItem && !selectedItem[\'@id\']">{{ getTitleField(selectedItem) }}</span> <button class="btn btn-link btn-xs" ng-show=selectedItem ng-click="selectedItem = undefined"><span class="glyphicon glyphicon-remove-sign text-muted"></span></button></span></div></div>');
$templateCache.put('forms/idai-search.html','<form ng-submit=search() class="idai-search input-group form-inline" role=search method=GET autocomplete=off><span class="input-group-btn scope-button" ng-if=hasSearchScope()><a ng-if=getSearchScope().page type=submit class="btn btn-default scope-button-main" ng-href={{getSearchScope().page}} title="{{getSearchScope().title || (\'navbar_this_scope\'|transl8)}}">{{getSearchScopeShortTitle() || (\'navbar_this_scope\'|transl8)}}</a> <span ng-if=!getSearchScope().page title="{{getSearchScope().title || (\'navbar_this_scope\'|transl8)}}" class="btn scope-button-pseudo">{{getSearchScopeShortTitle() || (\'navbar_this_scope\'|transl8)}}</span> <span class="btn btn-default scope-button-leave" ng-click=leaveSearchScope() title="{{getSearchScope().leaveText || (\'navbar_leave_scope\'|transl8)}}"><span class="glyphicon glyphicon-remove"></span></span></span> <input type=text ng-model=q name=q uib-typeahead="suggestion for suggestion in getSuggestions($viewValue)" ng-focus=selectQueryString($event) typeahead-on-select=search($item) typeahead-focus-first=false typeahead-select-on-exact=true class=form-control autofocus typeahead-popup-template-url=customPopupTemplate.html placeholder="{{(\'navbar_placeholder_search\'|transl8)}}"> <span class=input-group-btn><button type=submit class="btn {{buttonClass}}"><span class="glyphicon glyphicon-search"></span></button></span></form><script type=text/ng-template id=customPopupTemplate.html><div class="custom-popup-wrapper" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" style="display: table;" ng-show="isOpen() && !moveInProgress" aria-hidden="{{!isOpen()}}"> <ul class="dropdown-menu" role="listbox"> <li class="uib-typeahead-match" ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option" id="{{::match.id}}" ng-show="!match.model.extra"> <div uib-typeahead-match index="$index" match="m.model=match.model.model; m.label=match.model.model; m" query="query" template-url="templateUrl"> </div> </li> <hr> <p>{{\'navbar_old_searches\'|transl8}}</p> <li class="uib-typeahead-match" ng-repeat="match in matches track by $index" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" id="x-{{::match.id}}" role="option" ng-class="{active: isActive($index) }" ng-show="match.model.extra"> <div uib-typeahead-match index="$index" match="m.model=match.model.model; m.label=match.model.model; m" query="query" template-url="templateUrl"> </div> </li> </ul> </div></script>');
$templateCache.put('layout/idai-footer.html','<style>\n    #footer .row {\n        padding-bottom: 10px;\n    }\n</style><div class=row><div class="col-md-12 text-center"><div class=row><a ng-repeat="(key, uri) in institutions" ng-href={{uri}}><img class=logoImage ng-src=img/logo_{{key}}.png></a></div><div class=row ng-if=hasTranscludedContent ng-transclude></div><div class=row><div ng-if=!hasTranscludedContent style="display: inline-block;">{{\'footer_licensed_under\'|transl8}} <a rel=license href=info/order>Creative Commons</a> |&nbsp;</div><span ng-repeat="link in dynamicLinkList"><a href=info/{{link.id}} class=linkitem>{{link.title}}</a>&nbsp;|&nbsp;</span> <a href={{dataProtectionPolicyUri}}>{{\'footer_privacy\'|transl8}}</a> &nbsp;|&nbsp; {{\'footer_bugs_to\'|transl8}} <a href=mailto:{{mailto}}>{{mailto}}</a></div><div class=row ng-show=version><small>{{version}}</small></div></div></div>');
$templateCache.put('layout/idai-form.html','<form name=form class=form-horizontal><ng-transclude></ng-transclude><div class=form-group><div class="col-sm-offset-3 col-sm-9"><button ng-click=submit() class="btn btn-primary" ng-class="{ disabled: form.$invalid }">{{ \'form_save\' | transl8 }}</button> <button ng-click=reset() class="btn btn-link">{{ \'form_reset\' | transl8 }}</button></div></div></form>');
$templateCache.put('layout/idai-header.html','<a ng-href={{link}} id=headerlink target=_blank><header id=teaser><div id=background style="background-image: url({{image}});"></div><div id=description>{{description}}</div></header></a>');
$templateCache.put('layout/idai-navbar.html','<nav class="navbar navbar-default navbar-fixed-top" role=navigation><div ng-init="isCollapsed = true"><div style="float: left;"><div class="pull-left idai-welt-menu"><ul class="nav navbar-nav"><li uib-dropdown><a href=# uib-dropdown-toggle><span class="glyphicon glyphicon-menu-hamburger burger-icon"></span> <img src=img/logo_idai.png id=brand-img></a><ul uib-dropdown-menu><iframe src=https://idai.world/config/idai-nav.html frameborder=0 style="height: 100vh; width: 200px;"></iframe></ul></li></ul></div><a href="/" class=pull-left id=projectLogo><img ng-src=img/logo_{{projectId}}.png style="height: 36px;"> {{projectId}}</a></div><idai-search class="navbar-left idai-navbar-search" ng-hide=hideSearchForm search-scope=searchScope button-class=btn-default></idai-search><div class=navbar-right style=display:inline><button class=navbar-toggle ng-click="isCollapsed = !isCollapsed" type=button><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div style=display:inline class=navbar-right><div ng-class="isCollapsed ? \'collapse\' : \'in\'" class="collapse navbar-collapse" uib-collapse=isCollapsed><ng-transclude></ng-transclude><ul class="nav navbar-nav"><li class=navbar-links ng-repeat="link in dynamicLinkList"><a ng-click=toggleNavbar() ng-href={{link.path}}{{link.id}}>{{link.title}}</a></li><li id=language-switcher ng-hide=hideLanguageSwitcher uib-dropdown><a href=# uib-dropdown-toggle><span class="glyphicon glyphicon-globe"></span> <span ng-show="langCode == \'de\'">Deutsch</span> <span ng-show="langCode == \'en\'">English</span></a><ul uib-dropdown-menu><li ng-class="{\'selected-language\': langCode == \'de\'}"><a ng-click="switchLanguage(\'de\')">Deutsch</a></li><li ng-class="{\'selected-language\': langCode == \'en\'}"><a ng-click="switchLanguage(\'en\')">English</a></li></ul></li><li id=usermenu-navbar><div ng-if=userObject.username ng-cloak uib-dropdown keyboard-nav><a href=bookmarks class="btn btn-default btn-sm navbar-btn" uib-dropdown-toggle><span class="glyphicon glyphicon-user"></span> &nbsp;{{userObject.username}} <span class=caret></span></a><ul uib-dropdown-menu role=menu style="margin-top:-11px; margin-right: 4px;"><div ng-include="\'partials/navbar-menu.html\'" include-replace></div><li class=divider></li><li><a ng-click=logoutFunction();><span class="glyphicon glyphicon-log-out"></span> &nbsp;{{\'navbar_sign_out\' | transl8}}</a></li></ul></div><div ng-if=!userObject.username ng-cloak class="btn-group btn-group-sm"><a type=button id=loginbutton class="btn btn-default navbar-btn" ng-click=loginFunction();><b><span class="glyphicon glyphicon-log-in"></span> &nbsp;{{\'navbar_sign_in\' | transl8}}</b></a> <a ng-if="!hideRegisterButton && !userObject.username" class="btn btn-default navbar-btn" href=register>{{\'navbar_sign_up\' | transl8}}</a></div></li><li ng-if=!hideContactButton style=margin-left:5px><div><a type=button href=contact class="btn btn-sm btn-default navbar-btn"><span class="glyphicon glyphicon-envelope"></span></a></div></li><li style=margin-right:30px></li></ul></div></div></div></nav>');
$templateCache.put('messages/idai-messages.html','<div ng-repeat="(transl8Key,message) in messages" ng-class="\'alert-\' + message.level" class="col-md-10 col-md-offset-1 alert text-center"><div class=alert-message><button class=close ng-click=remove(transl8Key) style=cursor:pointer;>&times;</button> <b ng-bind-html=message.text></b><br><span>{{message.contactInfo}}</span></div></div>');}]);